(function () {
  function getNumberFromCSSVar(element, variableName, fallback) {
    const value = getComputedStyle(element).getPropertyValue(variableName).trim();
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function findNearestSnapIndex(swiper, progress) {
    const maxOffset = Math.max(swiper.virtualSize - swiper.size, 0);
    const targetOffset = progress * maxOffset;

    let closestIndex = 0;
    let smallestDistance = Infinity;

    swiper.snapGrid.forEach(function (snapPoint, index) {
      const distance = Math.abs(snapPoint - targetOffset);

      if (distance < smallestDistance) {
        smallestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function createProgressController(swiper, section) {
    const progressRoot = section.querySelector('[data-progress]');
    const track = progressRoot ? progressRoot.querySelector('.hm-collections-carousel__progress-track') : null;
    const thumb = progressRoot ? progressRoot.querySelector('[data-progress-thumb]') : null;

    if (!progressRoot || !track || !thumb) {
      return;
    }

    let isPointerDown = false;
    let hasMoved = false;

    function updateThumb() {
      const swiperSize = Number(swiper.size) || swiper.el.clientWidth || 0;
      const swiperVirtualSize = Number(swiper.virtualSize) || swiper.wrapperEl.scrollWidth || 0;
      const totalScrollable = Math.max(swiperVirtualSize - swiperSize, 0);

      if (!swiperSize || !swiperVirtualSize) {
        thumb.style.width = '50%';
        thumb.style.left = '0%';
        thumb.style.transform = 'none';
        return;
      }

      if (totalScrollable <= 0) {
        thumb.style.width = '100%';
        thumb.style.left = '0%';
        thumb.style.transform = 'none';
        return;
      }

      const visiblePercent = clamp((swiperSize / swiperVirtualSize) * 100, 12, 100);
      const progress = clamp(Number(swiper.progress) || 0, 0, 1);
      const maxLeft = 100 - visiblePercent;
      const leftPercent = maxLeft * progress;

      thumb.style.width = visiblePercent + '%';
      thumb.style.left = leftPercent + '%';
      thumb.style.transform = 'none';
    }



    function progressFromPointer(event) {
      const rect = track.getBoundingClientRect();
      const thumbWidth = thumb.getBoundingClientRect().width;
      const usableWidth = Math.max(rect.width - thumbWidth, 1);
      const raw = event.clientX - rect.left - (thumbWidth / 2);

      return clamp(raw / usableWidth, 0, 1);
    }

    function setFromProgress(progress, shouldSnap) {
      if (shouldSnap) {
        const targetIndex = findNearestSnapIndex(swiper, progress);
        swiper.slideTo(targetIndex);
        return;
      }

      swiper.setProgress(progress, 0);
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
      updateThumb();
    }

    function onPointerDown(event) {
      isPointerDown = true;
      hasMoved = false;
      track.setPointerCapture(event.pointerId);
      setFromProgress(progressFromPointer(event), false);
      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!isPointerDown) {
        return;
      }

      hasMoved = true;
      setFromProgress(progressFromPointer(event), false);
      event.preventDefault();
    }

    function onPointerUp(event) {
      if (!isPointerDown) {
        return;
      }

      isPointerDown = false;
      track.releasePointerCapture(event.pointerId);
      setFromProgress(progressFromPointer(event), true);
      event.preventDefault();
    }

    function onPointerCancel(event) {
      if (!isPointerDown) {
        return;
      }

      isPointerDown = false;
      track.releasePointerCapture(event.pointerId);

      if (hasMoved) {
        swiper.slideToClosest();
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerCancel);

    swiper.on('init', updateThumb);
    swiper.on('resize', updateThumb);
    swiper.on('setTranslate', updateThumb);
    swiper.on('slideChange', updateThumb);
    swiper.on('transitionEnd', updateThumb);

    requestAnimationFrame(updateThumb);
    window.setTimeout(updateThumb, 120);
    window.setTimeout(updateThumb, 300);
  }

  function bindMobileTileFocus(swiper, section) {
    section.addEventListener('click', function (event) {
      const tile = event.target.closest('.hm-collections-carousel__tile');

      if (!tile) {
        return;
      }

      if (window.innerWidth >= 992) {
        return;
      }

      const slide = tile.closest('.hm-collections-carousel__slide');

      if (!slide) {
        return;
      }

      const slideIndex = Array.prototype.indexOf.call(swiper.slides, slide);

      if (slideIndex === -1) {
        return;
      }

      if (swiper.activeIndex !== slideIndex) {
        event.preventDefault();
        swiper.slideTo(slideIndex);
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.hmCarouselInitialized === 'true') {
      return;
    }

    const swiperElement = section.querySelector('.hm-collections-carousel__swiper');

    if (!swiperElement || typeof Swiper === 'undefined') {
      return;
    }

    const slideCount = section.querySelectorAll('.hm-collections-carousel__slide').length;

    if (!slideCount) {
      return;
    }

    const mobileGap = getNumberFromCSSVar(section, '--hm-tile-gap-mobile', 8);
    const desktopGap = getNumberFromCSSVar(section, '--hm-tile-gap-desktop', 12);
    const mobileSlidesPerView = slideCount === 1 ? 1 : 1.2;
    const desktopSlidesPerView = Math.min(
      parseFloat(swiperElement.getAttribute('data-desktop-slides-per-view')) || 3,
      slideCount
    );




    swiperElement.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    section
      .querySelectorAll('.hm-collections-carousel__tile, .hm-collections-carousel__image, .hm-collections-carousel__brand-image')
      .forEach(function (node) {
        node.setAttribute('draggable', 'false');
      });

    const swiper = new Swiper(swiperElement, {
      slidesPerView: mobileSlidesPerView,
      slidesPerGroup: 1,
      spaceBetween: mobileGap,
      speed: 500,
      threshold: 6,
      watchOverflow: true,
      grabCursor: true,
      allowTouchMove: true,
      simulateTouch: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1
      },
      breakpoints: {
        992: {
          slidesPerView: desktopSlidesPerView,
          slidesPerGroup: 1,
          spaceBetween: desktopGap
        }
      }
    });


    createProgressController(swiper, section);
    bindMobileTileFocus(swiper, section);

    requestAnimationFrame(function () {
      swiper.update();
      swiper.slideTo(0, 0);
    });

    window.setTimeout(function () {
      swiper.update();
    }, 150);

    section.dataset.hmCarouselInitialized = 'true';
    section.hmCollectionsCarouselSwiper = swiper;

  }

  function initAll(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('.hm-collections-carousel');

    sections.forEach(function (section) {
      initSection(section);
    });
  }

  if (!window.HMCollectionsCarousel) {
    window.HMCollectionsCarousel = {
      initAll: initAll
    };

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
